import { ILivePosition, IPosition, IGetMapBoundary } from '../../api';

export interface ILatLng {
  lat: number;
  lng: number;
}

export abstract class MapViewService {
  abstract createMap(url: string, target: string | HTMLElement, className: string): void;
  abstract destroyMap(): void;
  abstract addPolylineLayer(latLons: ILatLng[], color: string): unknown;
  abstract setPolylineLayerPositions(layer: unknown, latLons: ILatLng[]): void;
  abstract removeLayer(track: unknown): void;
  abstract addCircleMarker(livePosition: ILivePosition, color: string, layer: unknown, mapType: string): unknown;
  abstract addCircleMarkersLayer(livePositions: ILivePosition[], color: string,mapType?:string): unknown;
  abstract removeCircleMarker(circleMarker: unknown): unknown;
  abstract addPositionMarker(livePosition: ILivePosition,mapType?:string): unknown;
  abstract modifyPositionMarker(marker: unknown, livePosition: ILivePosition, mapType?:string): void;
  abstract removePositionMarker(marker: unknown): void;
  abstract zoomToLayer(layer: unknown, userMapClick?:boolean): void;
  abstract zoomToPositions(positions: IPosition[]): void;
  abstract zoomToPositionMarkers(markers: unknown[]): void;
  abstract zoomToPositionMarkersOperational(markers: unknown[], maxZoom?: number): void;
  abstract changePathLayerColor(layer: unknown, color: string): void;
  abstract changeGroupLayerColor(layer: unknown, color: string): void;
  abstract createRendezvousMarkerLayer(positions:unknown, appliedRadius:number): unknown;
  abstract getMapBoundary():IGetMapBoundary;
  abstract MapMoved(fn: () => void):void;
  abstract getCurrentZoomLevel():number;
  abstract updateMoveendStatus(value:boolean):void;
  abstract removeallLayer():void;
  abstract updateMapSize():unknown;
}

export abstract class TrackViewService {
  abstract setDistance(distance: number): void;
  abstract getDistance(): number;
  abstract setTime(time: string):void;
  abstract getTime(): string;
  abstract removeAllLayer(): void;
  abstract getTimeInMilliseconds():number;
}
